import { t } from 'i18next'
import { Button } from 'primereact/button'
import React, { Fragment } from 'react'

export const actionBody = (edit: (rowData: any) => void) => {
  // eslint-disable-next-line react/display-name
  return (rowData: any) => (
    <Button
      type={'button'}
      icon="fa-solid fa-pen"
      className="p-button-primary p-button-text"
      onClick={() => edit(rowData)}
      style={{ maxHeight: '34px', maxWidth: '34px' }}
      tooltip={t<string>('core.edit')}
      // tooltipOptions={{/*position:'left',*/ showDelay: 800 }}
      tooltipOptions={{ style: { minWidth: '100px' } }}
    />
  )
}

export const actionBodyAdd = (add: (rowData: any) => void) => {
  // eslint-disable-next-line react/display-name
  return (rowData: any) => (
    <Button
      type={'button'}
      icon="fa-solid fa-plus-circle"
      className="p-button-primary p-button-text icon-red"
      onClick={() => add(rowData)}
      style={{ maxHeight: '34px', maxWidth: '34px' }}
      tooltip={t<string>('core.add')}
      // tooltipOptions={{/*position:'left',*/ showDelay: 800 }}
      tooltipOptions={{ style: { minWidth: '100px' } }}
    />
  )
}

export const actionBodyDelete = (
  removeElement: (rowData: any) => void
): ((rowData: any) => JSX.Element) => {
  // eslint-disable-next-line react/display-name
  return (rowData: any) => {
    return (
      <Button
        type={'button'}
        icon="fa-solid fa-trash"
        className="p-button-danger p-button-text ml-auto"
        tooltip={t<string>('core.delete')}
        tooltipOptions={{ style: { minWidth: '100px' }, showDelay: 500 }}
        onClick={() => removeElement(rowData)}
      />
    )
  }
}
export const actionBodyRemove = (
  removeElement: (rowData: any) => void
): ((rowData: any) => JSX.Element) => {
  // eslint-disable-next-line react/display-name
  return (rowData: any) => {
    return (
      <Button
        type={'button'}
        icon="fa-solid fa-times-circle"
        className="p-button-danger p-button-text ml-auto"
        tooltip={t<string>('core.remove')}
        tooltipOptions={{ style: { minWidth: '100px' } }}
        onClick={() => removeElement(rowData)}
      />
    )
  }
}

export const actionBodyWithDelete = (
  edit: (rowData: any) => void,
  removeElement: (rowData: any) => void
): ((rowData: any) => JSX.Element) => {
  // eslint-disable-next-line react/display-name
  return (rowData: any): JSX.Element => {
    return (
      <div className={'inline-flex'}>
        <Button
          type={'button'}
          icon="fa-solid fa-pen"
          className="p-button-primary p-button-text"
          tooltip={t<string>('core.edit')}
          tooltipOptions={{ position: 'left' }}
          onClick={() => edit(rowData)}
        />
        <Button
          type={'button'}
          icon="fa-solid fa-trash"
          className="p-button-danger p-button-text"
          onClick={() => removeElement(rowData)}
          tooltip={t<string>('core.delete')}
          tooltipOptions={{ position: 'left' }}
        />
      </div>
    )
  }
}

export const actionBodyWithEditAndDelete = (
  edit: (rowData: any) => void,
  removeElement: (rowData: any) => void
): ((rowData: any) => JSX.Element) => {
  // eslint-disable-next-line react/display-name
  return (rowData: any) => {
    return (
      <Fragment>
        <Button
          type={'button'}
          icon="fa-solid fa-pen"
          className="p-button-primary p-button-text mr-1"
          onClick={() => edit(rowData)}
          tooltip={t<string>('core.edit')}
          style={{ maxHeight: '30px', maxWidth: '30px' }}
          tooltipOptions={{
            position: 'left',
            style: { width: '110px', textAlign: 'center' },
          }}
        />
        <Button
          type={'button'}
          icon="fa-solid fa-trash"
          className="p-button-danger p-button-text"
          onClick={() => removeElement(rowData)}
          tooltip={t<string>('core.delete')}
          style={{ maxHeight: '30px', maxWidth: '30px', whiteSpace: 'nowrap' }}
          tooltipOptions={{
            style: { width: '110px', textAlign: 'center' },
            position: 'left',
          }}
        />
      </Fragment>
    )
  }
}

export const actionBodyWithEditAndDeleteWhenUnsigned = (
  edit: (rowData: any) => void,
  removeElement: (rowData: any) => void
): ((rowData: any) => JSX.Element) => {
  // eslint-disable-next-line react/display-name
  return (rowData: any) => {
    return (
      <Fragment>
        {rowData.signed_file_reference ? (
          <span className={'mr-6'} />
        ) : (
          <Button
            type={'button'}
            icon="fa-solid fa-pen"
            style={{ maxHeight: '30px', maxWidth: '30px' }}
            className=" p-button-primary p-button-text mr-1"
            onClick={() => edit(rowData)}
          />
        )}
        <Button
          type={'button'}
          icon="fa-solid fa-trash"
          style={{ maxHeight: '30px', maxWidth: '30px', whiteSpace: 'nowrap' }}
          className="p-button-danger p-button-text"
          onClick={() => removeElement(rowData)}
        />
      </Fragment>
    )
  }
}